import React from 'react';
import AddItemBtn from '../atoms/AddItemBtn';
import InfoText from '../atoms/InfoText';

export default function FormSectionTitle({
  title,
  subTitle,
  onClick,
  buttonText,
  buttonId,
  dataTestId,
  className,
  disblaeBtn,
}: {
  title: string;
  subTitle: string;
  onClick: () => void;
  buttonText: string;
  buttonId: string;
  dataTestId?: string;
  className?: string;
  disblaeBtn?: boolean;
}) {
  return (
    <div className={className || 'mb-9'} data-testid="profile-creation-form-section-title">
      <div className="flex flex-col gap-1">
        <div className="flex justify-between items-center">
          <InfoText
            text={title}
            size="2xl"
            className="!font-bold !text-light-button-primary dark:!text-dark-text-primary"
          />
          {!disblaeBtn && buttonText && (
            <AddItemBtn
              onClick={onClick}
              disblaeBtn={disblaeBtn}
              id={buttonId}
              dataTestId={dataTestId}
              type="button"
              text={buttonText}
            />
          )}
        </div>

        <InfoText text={subTitle} className="!text-gray-500" />
      </div>
    </div>
  );
}
